import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PendingChange } from 'src/app/modules/shared/models/detect-change';

@Component({
  selector: 'app-logout-modal',
  standalone: false,
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.scss']
})
export class LogoutModalComponent {

  changes: PendingChange[] = [];
  message: string;

  constructor(public activeModal: NgbActiveModal) { }
}
